import React, { useState } from "react";
import BennyForm from "../BennyForm";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import helpIcon from "../../images/individual/helpIcon.svg";
import { FaPlus, FaTimes } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import checkmarkSeal from "../../images/employee/checkmark-seal.svg";
import helpImmiget from "../../images/individual/benny.jpg";
import { Helmet } from "react-helmet-async";
import BenyHeader from "./BenyHeader";

const BenyPartnership = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <div>
      <Helmet>
        <title>The Competitive Edge for Forward-Thinking Employers</title>
        <meta
          name="description"
          content="At Immiget Global, we do more than Employer-Sponsored Visas. We help businesses like yours attract, support, and retain the global talent that drives innovation and growth."
        />
      </Helmet>
      <BenyHeader />
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <h1 className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              The Competitive Edge for Forward-Thinking Employers
            </h1>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                For Employers
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Beny For Migration
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Partnership Overview */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[30px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            Beyond Employer-Sponsored Visas
          </h1>
          <div className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
            At Immiget Global, we do more than Employer-Sponsored Visas. We help businesses like yours attract, support, and retain the global talent that drives innovation and growth.
            Through our exclusive partnership with Beny, we're redefining what it means to support international hires — not just on paper, but in the real world.
          </div>
          <div className="max-xl:text-center mt-6 mb-6">
            <div className="relative inline-block max-w-[90%] xl:max-w-[85%]">
              <div className="absolute inset-0 bg-gradient-to-r from-blue/20 to-[#4dabf7]/30 rounded-lg transform -rotate-1 scale-103"></div>
              <div className="relative bg-white border-2 border-blue/30 rounded-lg shadow-lg py-4 px-6 transform hover:scale-102 transition-transform duration-300">
                <p className="hellix-font text-blue text-lg xl:text-[20px] font-normal">
                  Our collaboration reaps many benefits, one of them being availing <span className="font-bold text-[#2E86DE] text-xl xl:text-[26px] animate-pulse">15% OFF</span> on all our services.
                </p>
                <div className="mt-3 flex justify-center">
                  <button>
                    <a onClick={() => {
                    const contactSection = document.getElementById('contact-section');
                    if (contactSection) {
                      contactSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }} className="bg-blue text-white font-semibold py-2 px-5 rounded-full hover:bg-opacity-90 transition duration-300 flex items-center">
                    <span>Claim Your Discount</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={helpImmiget} alt="Immiget Global Partnership" className="rounded-lg" />
        </div>
      </div>
      
      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>
      
      {/* Real-World Support Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            A Real-World Support for Global Talent
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          As a migration agency specializing in Employer Sponsored Visas, we work with forward-thinking companies to not only navigate migration pathways but to build a talent experience that lasts.
        </div>
        <div className="text-blue font-semibold text-lg lg:text-[22px] mt-4 hellix-font text-center">
          We make migration simple, clear, and successful.
        </div>
      </div>
      
      {/* What Sets Us Apart */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-6 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits icon" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            What Sets Us Apart
          </h1>
        </div>
        
        <div className="lg:ml-4 mt-6">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              98.9% Visa Approval Rate
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              2100+ Visas Granted
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              600+ Positive Reviews
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              5+ Years of Experience
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              Registered Migration Agents
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              Fast-Tracked Processing & Clear Communication
            </div>
          </div>
        </div>
      </div>
      
      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>
      
      {/* Visa Types Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-6 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits icon" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            EMPLOYER SPONSORED VISAS WE HELP YOU WITH
          </h1>
        </div>
        
        <div className="mt-8">
          <h3 className="text-blue text-xl font-semibold hellix-font mb-4">Permanent Visas:</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="shadow-custom-white p-6 rounded-[16px]">
              <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Subclass 186 – Employer Nomination Scheme Visa</h3>
              <p className="text-blue text-lg font-normal hellix-font">
                A permanent residency visa for skilled workers nominated by an approved Australian employer to fill a full-time position.
              </p>
            </div>
            
            <div className="shadow-custom-white p-6 rounded-[16px]">
              <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Subclass 187 – Regional Sponsored Migration Scheme Visa</h3>
              <p className="text-blue text-lg font-normal hellix-font">
                A permanent visa (previously available) for skilled workers nominated by an employer in regional Australia.
              </p>
            </div>
            
            <div className="shadow-custom-white p-6 rounded-[16px]">
              <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Subclass 494 – Skilled Employer Sponsored Regional (Provisional) Visa</h3>
              <p className="text-blue text-lg font-normal hellix-font">
                A 5-year provisional visa for skilled workers sponsored by regional employers, offering a pathway to permanent residency after 3 years.
              </p>
            </div>
          </div>
          
          <h3 className="text-blue text-xl font-semibold hellix-font mb-4 mt-8">Temporary Visas:</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="shadow-custom-white p-6 rounded-[16px]">
              <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Subclass 400 – Temporary Work (Short Stay Specialist) Visa</h3>
              <p className="text-blue text-lg font-normal hellix-font">
                A short-term visa for professionals with highly specialized skills needed for non-ongoing work or urgent projects in Australia (up to 3–6 months).
              </p>
            </div>
            
            <div className="shadow-custom-white p-6 rounded-[16px]">
              <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Subclass 407 – Training Visa</h3>
              <p className="text-blue text-lg font-normal hellix-font">
                A temporary visa for individuals undertaking structured workplace-based training or professional development in Australia.
              </p>
            </div>
            
            <div className="shadow-custom-white p-6 rounded-[16px]">
              <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Subclass 482 – Temporary Skill Shortage (TSS) Visa</h3>
              <p className="text-blue text-lg font-normal hellix-font">
                A temporary visa that allows Australian employers to sponsor skilled overseas workers to fill labor shortages, with potential PR pathways.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* CTA Section */}
      <div className="container max-w-1440px mx-auto px-4 py-10 lg:px-14">
        <div className="bg-[#F4FFFC] rounded-lg p-8 text-center">
          <h2 className="text-blue text-xl lg:text-[28px] font-bold hellix-font mb-4">
            Let's Redefine What Employee Sponsorship Looks Like – How We Can Help?
          </h2>
          <p className="text-blue text-lg lg:text-[20px] font-normal hellix-font mb-6">
            If you're ready to transform your approach to sponsored employment — from compliance-driven to people-first — Immiget Global is your partner. We'll handle the migration complexity while helping you build a benefits ecosystem that sets your business apart in Australia's competitive talent market.
          </p>
          <p className="text-blue text-lg lg:text-[20px] font-normal hellix-font mb-6">
            Bring in the best, and help them stay at their best — with Immiget Global.
          </p>
          <p className="text-blue text-lg lg:text-[20px] font-normal hellix-font mb-6">
            Immigration brings talent in — strategic benefits help them stay. Partner with Immiget Global to go beyond visas and build a workplace where international hires thrive.
          </p>
          <button onClick={() => {
            const contactSection = document.getElementById('contact-section');
            if (contactSection) {
              contactSection.scrollIntoView({ behavior: 'smooth' });
            }
          }} className="inline-block bg-blue text-white font-semibold py-3 px-8 rounded-full hover:bg-opacity-90 transition duration-300">
            Contact Us Today
          </button>
        </div>
      </div>

      <BennyForm />
    </div>
  );
};

export default BenyPartnership;